module.exports = __webpack_public_path__ + "img/dxlogo.d2c61ce2.png";